import {AppState} from '../reducer';

export const isLoadingSelector = (state: AppState): boolean => state.spinnerReducer.isLoading;
